import React, { useRef, useContext, useCallback } from 'react';
import CloseIcon from '@mui/icons-material/Close';

import { useOnClickOutside } from '../../../../../hooks/useOnClickOutside/useOnClickOutside';
import BentoMenuButton from './BentoMenuButton/BentoMenuButton';
import { context } from '../../../../Theme/Context';

import './MainMenu.css';
import MenuItemsTop from './MenuItemsTop';
import MenuItemsBottom from './MenuItemsBottom';
import cn from 'utils/cn';

const menuWidth = 200;
const closeIconWidth = 40;

type TProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  className?: string;
  isBentoCircle: boolean;
};

function MainMenu({ isOpen = false, setIsOpen, className = '', isBentoCircle = true }: TProps) {
  const closeMenu = useCallback(() => setIsOpen(false), [setIsOpen]);

  const closeIfOpen = useCallback(() => {
    if (isOpen) {
      closeMenu();
    }
  }, [isOpen, closeMenu]);

  const menuRef = useRef<HTMLDivElement | null>(null);

  useOnClickOutside(menuRef, closeIfOpen);

  const theme = useContext(context);

  return (
    <div ref={menuRef} className="tw:flex">
      <div
        className={cn('main-navigation-menu Roboto tw:flex absolute z-999', className)}
        style={{
          left: isOpen ? 0 : -(menuWidth + closeIconWidth),
          top: 0,
          zIndex: isOpen ? 10003 : 999,
        }}
      >
        <div
          className="tw:text-primary-100 tw:bg-secondary-400 tw:flex-col tw:flex tw:justify-between"
          style={{
            width: menuWidth,
            height: '100vh',
          }}
        >
          <MenuItemsTop closeMenu={closeMenu} />
          <MenuItemsBottom closeMenu={closeMenu} />
        </div>
        <div
          className="tab-height tw:flex tw:items-center tw:justify-center"
          style={{
            backgroundColor: theme.colors.background,
            color: theme.colors.foreground,
          }}
          onClick={closeMenu}
        >
          <CloseIcon
            style={{
              fontSize: closeIconWidth,
              color: theme.colors.foreground,
            }}
          />
        </div>
      </div>

      <BentoMenuButton isOpen={isOpen} setIsOpen={setIsOpen} isCircle={isBentoCircle} />
    </div>
  );
}

export default MainMenu;
